var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgComment = function SvgComment(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-198 217.5 46 44.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-157.9 217.5l-34.1.1c-3.3 0-5.9 2.7-5.9 5.9v21.1c0 3.3 2.7 5.9 5.9 5.9h6.1v10c0 .4.3.8.6.9.1 0 .2.1.4.1.3 0 .5-.1.7-.3l9.7-10.7 16.6-.1c3.3 0 5.9-2.7 5.9-5.9v-21.1c0-3.3-2.7-5.9-5.9-5.9zm-28.1 20.9c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4c0 2.3-1.8 4-4 4zm11 0c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4c0 2.3-1.8 4-4 4zm11 0c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4c0 2.3-1.8 4-4 4z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comment.df0ace80.svg";
export { ForwardRef as ReactComponent };